// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__94VC6","selected":"Chip_selected__2vKQc"};